import { content } from '../data/content';
import { useDragScroll } from '../hooks/useDragScroll';
import { SectionHeading } from './ui/Ui';

/**
 * صور العلامة نفسها بدل صور Unsplash العامة: خلفية كحلية موحّدة تطابق لون
 * البراند، وتزول معها ثلاثة طلبات لنطاق خارجي كانت تبطّئ الصفحة.
 */
const SOLUTIONS = [
  { label: content.sol1, img: '/use-shirt.jpg' },
  { label: content.sol2, img: '/use-dress.jpg' },
  { label: content.sol3, img: '/use-home.jpg' },
];

/**
 * توسيع الاستخدامات يرفع القيمة المدركة للسعر.
 * أزلنا رابط «كل منتجاتنا» لأنه كان مخرجاً من الصفحة قبل إتمام الطلب.
 */
export default function Solutions() {
  const { ref, handlers } = useDragScroll();

  return (
    <section className="py-10 md:py-20 bg-white">
      <div className="container mx-auto">
        <SectionHeading
          eyebrow={content.solutionsEyebrow}
          icon="fa-shirt"
          iconColor="text-z-orange"
          title={content.solutionsTitle}
        />

        <div
          ref={ref}
          {...handlers}
          className="flex gap-6 overflow-x-auto pb-8 hide-scroll cursor-grab active:cursor-grabbing justify-start lg:justify-center"
        >
          {SOLUTIONS.map((sol) => (
            <div
              key={sol.label}
              className="min-w-[250px] md:min-w-[300px] relative rounded-2xl overflow-hidden shadow-md"
            >
              {/* إطار مربّع يطابق نسبة الصور 1:1 فتظهر كاملة بلا قصّ */}
              <img
                src={sol.img}
                alt={sol.label}
                width="800"
                height="800"
                className="w-full aspect-square object-cover"
                loading="lazy"
              />
              {/*
                شريط كحلي مصمت بدل التدرّج الشفاف فوق الصورة: أدوات فحص
                التباين لا تستطيع حساب نسبة نصٍّ فوق تدرّج أو صورة فتعدّه
                راسباً، والأهم أن وضوح النص كان يعتمد على درجة الصورة تحته.
              */}
              <div className="absolute inset-x-0 bottom-0 bg-z-navy px-5 py-4">
                <h3 className="text-white text-lg md:text-xl font-bold font-serif">{sol.label}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
